import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col, Card, Tabs, Tab  } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonSelect from '../components/CommonSelect';
import CommonRadio from '../components/CommonRadio';

/**
import CommonInput from '../components/CommonInput';
import CommonFile from '../components/CommonFile';
import CommonCheckbox from '../components/CommonCheckbox';
import CustomDatePicker from "../components/CommonDatePicker";
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

class InputUserDataPermission extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            activeTab: 'typeA',
        };
    }
    
    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
    }
    
    handleTabSelect = (key) => { this.setState({ activeTab: key }); };     
    
    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }
    
    prepareInputs = async () => {
        const { Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';
    
        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }
    
    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '70%' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => {
                        this.setState({activeTab: 'typeA'});
                        props.onClose(e)
                    }}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">

                                <Tabs 
                                    defaultActiveKey="typeA" 
                                    activeKey={this.state.activeTab}
                                    onSelect={(e) => this.handleTabSelect(e)}
                                    className="mb-3"
                                >
                                    
                                    <Tab eventKey="typeA" title="หลักสูตร Type A">
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_model_type_a_student}
                                                    radio={InputGroup.Radio.eec_model_type_a_student}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_model_type_a_import}
                                                    radio={InputGroup.Radio.eec_model_type_a_import}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>

                                    <Tab eventKey="typeB" title="หลักสูตร Type B">
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_model_type_b_eb1}
                                                    radio={InputGroup.Radio.eec_model_type_b_eb1}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_model_type_b_eb2}
                                                    radio={InputGroup.Radio.eec_model_type_b_eb2}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_model_type_b_eb3}
                                                    radio={InputGroup.Radio.eec_model_type_b_eb3}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>

                                    <Tab eventKey="demand" title="ความต้องการกำลังคน">
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.demand_supply_manpower}
                                                    radio={InputGroup.Radio.demand_supply_manpower}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.demand_supply_resource}
                                                    radio={InputGroup.Radio.demand_supply_resource}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.demand_supply_matching}
                                                    radio={InputGroup.Radio.demand_supply_matching}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                    
                                    <Tab eventKey="publicize" title="ประชาสัมพันธ์">
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.publicize_academy_and_course}
                                                    radio={InputGroup.Radio.publicize_academy_and_course}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.publicize_news}
                                                    radio={InputGroup.Radio.publicize_news}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.publicize_vacancies}
                                                    radio={InputGroup.Radio.publicize_vacancies}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                    
                                    <Tab eventKey="eec" title="ศูนย์เครือข่าย">    
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.eec_nets}
                                                    radio={InputGroup.Radio.eec_nets}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                    
                                    <Tab eventKey="users" title="ผู้ใช้และระดับสิทธิ์">    
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.enterprise}
                                                    radio={InputGroup.Radio.enterprise}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.academy}
                                                    radio={InputGroup.Radio.academy}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.external_user}
                                                    radio={InputGroup.Radio.external_user}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.users}
                                                    radio={InputGroup.Radio.users}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <CommonRadio
                                                    element="Inputs"
                                                    input={Inputs.permission}
                                                    radio={InputGroup.Radio.permission}
                                                    hr={true}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>

                                </Tabs>                          
                            </Container>     
                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => await onSubmit(e) } 
                            />
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputUserDataPermission;